export var createMuiDialogContentTextOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            marginBottom: spacing(8),
        },
    });
};
//# sourceMappingURL=MuiDialogContentText.js.map